module.exports = __webpack_public_path__ + "img/photo.334ce0f7.png";